module.exports = __webpack_public_path__ + "static/media/physicswallah.b7dce1c9.webp";